<div class="search-box-wide arrow-right eip-mt-20 eip-ml-0 eip-mr-0 eip-pxy-20 reset-row">
  <div class="d-block d-sm-none">
    <i class="fa fa-times-circle close-btn" (click)="closeAdvanceSearch($event)"></i>
  </div>
  <form [formGroup]="searchForm">
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <mat-form-field style="width:100%;">
          <mat-label>Free Search</mat-label>
          <input matInput formControlName="ctrlSearchText">
        </mat-form-field>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <EIPAutoComplete id="actxtwarehouse" WaterMarkText="Type" TextField="description" ValueField="value"
          ShowTextValueField='N' [dataSource]='searchTypeList' formControlName="ctrlType">
        </EIPAutoComplete>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <EIPAutoComplete ShowTextValueField='N' WaterMarkText="Discipline" TextField="description" ValueField="value"
          [dataSource]='searchDisciplineList' formControlName="ctrlDisc" [IsCascading]='true'>
        </EIPAutoComplete>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <EIPAutoComplete WaterMarkText="Revision" ShowTextValueField='N' TextField="description" ValueField="value"
          [dataSource]='searchRevisionList' [IsCascading]='true' formControlName="ctrlRevision">
        </EIPAutoComplete>
      </div>
      <div class="eip-pr-20 adv-srch-btns eip-ml-auto eip-mt-10">
        <input type="submit" value="Clear" class="btn btn-secondary" id="BtnClear" (click)="clearSearch()">
        <input type="submit" value="Search" (click)="searchData()" class="btn btn-primary eip-ml-20" id="btnSearch">
      </div>
    </div>
  </form>
</div>